import { Outlet } from 'react-router';

import type { AnyRoutesConfig } from '@virtuslab/nfs-shared/src/services/hooks/useRoutes';
import { emptyRoutesConfig } from '@virtuslab/nfs-shared/src/services/hooks/useRoutes';
import { mergeConfigs } from '@virtuslab/nfs-shared/src/services/routes';
import type { RoutesConfig, WrapRoutes } from '@virtuslab/nfs-shared/src/services/routes';

import SecureRoutesWrapper from '../components/organisms/SecureRoutesWrapper';
import absences from '../components/pages/Absences/config';
import login from '../components/pages/AuthLogin/config';
import logout from '../components/pages/AuthLogout/config';
import benefits from '../components/pages/Benefits/config';
import businessTravels from '../components/pages/BusinessTravels/config';
import dashboard from '../components/pages/Dashboard/config';
import directReporting from '../components/pages/DirectReporting/config';
import error404 from '../components/pages/Error404/config';
import myProfile from '../components/pages/MyProfile/config';
import office from '../components/pages/Office/config';
import progression from '../components/pages/Progression/config';
import projects from '../components/pages/Projects/config';
import settings from '../components/pages/Settings/config';
import timeReport from '../components/pages/TimeReport/config';

import { BaseRoutes } from './paths';

const defaultSecureConfig: RoutesConfig<WrapRoutes<typeof BaseRoutes>> = {
  paths: {
    [BaseRoutes.BASE]: {
      render: SecureRoutesWrapper,
    },
    [BaseRoutes.CONTRACT_ROUTE]: {
      render: () => <Outlet />,
    },
  },
};

const secureRoutes: AnyRoutesConfig = ([
  defaultSecureConfig,
  timeReport,
  absences,
  office,
  businessTravels,
  dashboard,
  benefits,
  settings,
  directReporting,
  projects,
  progression,
  myProfile,
  error404,
] as AnyRoutesConfig[]).reduce(mergeConfigs, emptyRoutesConfig);

const insecureRoutes: AnyRoutesConfig = [
  login,
  logout,
].reduce(mergeConfigs, emptyRoutesConfig);

const config = mergeConfigs(insecureRoutes, secureRoutes);

export default config;
